const header = document.querySelector("header");

if (header) {
  //!---------- Drop down lodge menu ----------
  const hover_link = header.querySelector(".hover-link");
  const dropdown_container = header.querySelector(".dropdown");

  let is_dropdown_active = false;

  hover_link.addEventListener("mouseenter", addDropdown);

  //# Throttled function to check the target of mouseover
  const checkMouse = throttle((event) => {
    //% Check if mouse is over link and dropdown
    const is_over_link = event.target === hover_link;
    const is_over_dropdown = dropdown_container.contains(event.target);

    //% If mouse leaves link or dropdown hitbox remove dropdown
    if (!is_over_link && !is_over_dropdown) {
      removeDropdown();
    }
  }, 200);

  //# Function to reveal dropdown
  function addDropdown() {
    if (is_dropdown_active) {
      return;
    }
    is_dropdown_active = true;

    //% Add extended hit box for hover link
    hover_link.classList.add("extend");

    //% Add dropdown class to header
    header.classList.add("drop-active");

    //% Add mouse event to check position of mouse inside header
    header.addEventListener("mousemove", checkMouse);

    //% Add event to remove dropdown if mouse leaves the header
    header.addEventListener("mouseleave", removeDropdown);
  }

  //# Function to hide dropdown
  function removeDropdown() {
    //% Remove active state from dropdown
    is_dropdown_active = false;

    //% Remove extended hit box for hover link
    hover_link.classList.remove("extend");

    //% Remove dropdown class to header
    header.classList.remove("drop-active");

    //% Remove mouse event to header to check mouse pos
    header.removeEventListener("mousemove", checkMouse);
    //% Remove mouseleave event from header
    header.removeEventListener("mouseleave", removeDropdown);
  }


  //!---------- Main menu logic ----------
  const hamburger = document.querySelector(".hamburger");
  const menu = header.querySelector(".menu");

  //% Collapse menu if mouse exits the header where menu is located
  header.onmouseleave = () => {
    hamburger.classList.remove("exit-state");
    header.classList.remove('menu-active');
  }
  
  hamburger.onclick = () => {
    hamburger.classList.toggle("exit-state");
    header.classList.toggle("menu-active");

    //% Toggle scroll ability on mobile
    if ( isMobile() ) {
      triggerEvent(window, "scroll_toggle");
    }

  };

}

